module.exports = __webpack_public_path__ + "img/pc_banner_rule.d6e48797.jpeg";